import { connect } from 'react-redux'
import { Dispatch } from 'redux'
import { toggleUpdateReservationModal } from '../../../../actions/bookingCalendar/reservationModal/toggleReservationModal'
import { IStore } from '../../../../reducers'
import requestUpdateEvent from '../../../../actions/bookingCalendar/event/requestUpdateEvent'
import {
  getEventById,
  getReservationStatusSettingsForEvent,
} from '../../../../reducers/bookingCalendar/selectors/events'
import openModal from '../../../../actions/Modals/openModal'
import closeModal from '../../../../actions/Modals/closeModal'
import {
  IEventHintDispatch,
  IEventHintProps,
  IEventHintState,
} from './EventHint'

function mapStateToProps(
  state: IStore,
  ownProps: IEventHintProps,
): IEventHintState {
  const event = getEventById(ownProps.eventId)(state)
  const statusSettings = getReservationStatusSettingsForEvent(state, {
    event,
  })
  return {
    event,
    statusSettings,
  }
}

const bindDispatchToProps = (dispatch: Dispatch): IEventHintDispatch => ({
  editEvent: id => () => dispatch(toggleUpdateReservationModal(id)),
  modalClose: id => {
    dispatch(closeModal(id))
  },
  modalOpen: (id, element) => () => {
    dispatch(openModal(id, element))
  },
  updateEvent: (event, eventId) => dispatch(requestUpdateEvent(event, eventId)),
})

export default connect<IEventHintState, IEventHintDispatch, IEventHintProps>(
  mapStateToProps,
  bindDispatchToProps,
)
